/** @module csi/widget/_svg/ModifyPlaceholderPoints */
define([
	"dijit/form/ToggleButton",
	"csi/locale",
	"csi/message",
	"csi/widget/MessageDialog",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(ToggleButton,locale,message,MessageDialog,_Plugin,PluginFactory,util) {

	return PluginFactory.declare([ToggleButton,_Plugin], {
		"class": "csi-button-toggle csi-single-toggle",
		bHideWhenDisabled: false,
		iconClass: "csiActionIcon svgIconPoints",
		pluginName: "placeholderPoints",
		title: "CanvasEditPoints",

		/**
		 * Only allow if this is edit mode for selected shape
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set('checked', this.editor.isEditCurveCanvasMode());

			if (shapes && shapes.length == 1) {
				var shape = shapes[0];

				return this.editor.isSelectedShapesSupportEditPoints() ||
					(shape.isPicture && !this.editor.canvasApp.selection.isSelectedShapeRounded());
			}
			return false;
		},

		/**
		 * Edit selected page object.
		 */
		onClick: function() {
			if (this.editor.getPrimarySelectedShape().isPicture) {
				this.editor.canvasApp.pageApi().changeShapeType("custom");
			}
			this.editor.editPointsPageObject();
		}
	});
});